import React, { Component, Fragment } from 'react';
import DataTables from 'organisms/DataTable';
import { SupportRequestModal, SupportRequestView } from 'organisms/NewTaskModal';
import ModalPage from 'templates/ModalPage';
import MonthYearInput from 'molecules/MonthYearInput';
import { SUPPORT_REQUEST } from 'fixtures/api';
import { NewSupportRequest } from 'fixtures/TemplateData';
import { taskRequestCreate } from 'fixtures/permissions';
import { permissionCheck } from 'helpers/permissionCheckHelper';
import { submitTask } from 'services/taskService';
import { getDeptsDataByCompany } from 'Redux/actions/DepartmentListActions'
import { getTaskListData } from 'Redux/actions/TaskActions';
import { getCCsData } from 'Redux/actions/CCListActions';
import { getContractorPitLookupData, getLookupByType, setPitPlanData } from 'Redux/actions/LookupActions';
import { toggleIsShowTab, toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { supportRequestConfig } from './tableConfig';
import { TableWrapper, BtnAddNew } from './styles';
import { withRouter } from 'react-router-dom';
import { withTheme } from 'styled-components';
import lo from 'lodash';

class SupportRequestList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isShowModalNew: false,
      isShowModalView: false,
      isSubmitDisabled: false,
      lookups: {
        contractors: [],
        pits: [],
        seams: [],
      },
      filter: {
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        status: ''
      },
      isShowFilter: false,
      NewTaskData: {},
      ViewTaskData: null,
      allowCreate: false
    }
  }

  // LIFECYCLES
  componentDidMount() {
    this.props.toggleIsShowTab(true)
    this.props.toggleIsLoading(true)
    this.props.getContractorPitLookupData()
    this.props.getLookupByType(SUPPORT_REQUEST)
    this.fetchNewTaskData()
    this.checkPermission()
  }

  componentDidUpdate(prevProps) {
    const { supportRequests, contractorPitLookups, deptLookups, effectivePitPlan, viewState: { isLoading }, userLogin, globals } = this.props
    const { lookups, NewTaskData } = this.state
    if (prevProps.supportRequests !== supportRequests && isLoading) {
      if (contractorPitLookups) {
        const obj = Object.assign(lookups)
        lookups.contractors = contractorPitLookups
        this.setState({ lookups: obj })
      }
      if (deptLookups) {
        const obj = Object.assign(lookups)
        lookups.depts = deptLookups
        this.setState({ lookups: obj })
      }
      this.props.toggleIsLoading(false)
    }
    if (prevProps.effectivePitPlan !== effectivePitPlan && isLoading) {
      const obj = Object.assign(lookups)
      const task = Object.assign(NewTaskData)

      lookups.seams = effectivePitPlan.seams
      task.seam = effectivePitPlan.seams[0] ? effectivePitPlan.seams[0] : '-'
      task.sectionFrom = effectivePitPlan.sectionFrom
      task.sectionTo = effectivePitPlan.sectionTo
      task.sectionPrefix = effectivePitPlan.sectionPrefix

      this.setState({ lookups: obj, NewTaskData: task }, () => {
        this.props.toggleIsLoading(false)
      })
    }
    if (prevProps.userLogin !== userLogin) {
      this.checkPermission()
    }
    if (prevProps.globals.company !== globals.company) {
      this.fetchNewTaskData()
    }
  }

  // METHODS
  // method for checking access permission
  checkPermission() {
    const { userLogin } = this.props
    if (userLogin && userLogin.userDetail) {
      const { userDetail: { permissions } } = userLogin
      this.setState({
        allowCreate: permissionCheck(permissions, taskRequestCreate),
      })
    }
  }

  // change filter state
  onChangeFilter(val, field) {
    let f = { ...this.state.filter }
    f[field] = val
    this.setState({ filter: f }, () => {
      this.fetchNewTaskData(f)
    })
  }

  fetchNewTaskData(filterData) {
    this.props.toggleIsLoading(true)
    const filter = { ...filterData || this.state.filter, companyId : this.props.globals.company ? this.props.globals.company.id : null }
    this.props.getTaskListData(SUPPORT_REQUEST, filter)
  }

  // handle search cc
  onSearchCC(keyword = '') {
    const { pitId } = this.state.NewTaskData
    const { getCCsData } = this.props
    if (!!pitId && pitId !== '-') {
      getCCsData(keyword, pitId)
    }
  }

  // change task data state
  onChange(val, field) {
    const { userLogin: { userDetail: { contractorId } } } = this.props
    let task = { ...this.state.NewTaskData }
    const isContractor = !!contractorId

    if (field === 'photosBase64') {
      const files = []
      const thumbs = []

      for (var i = 0; i < val.length; i++) {
        const file = val[i]
        let reader = new FileReader()
        reader.addEventListener("load", (event) => {
          thumbs.push(event.target.result) // non-trimmed base64 for preview
          files.push(event.target.result.split(',')[1]) // trimmed base64 for posting
          task[field] = files
          task.photo = thumbs
          this.setState({ NewTaskData: task })
        })
        reader.readAsDataURL(file)
      }
    } else {
      task[field] = val
    }

    this.setState({ NewTaskData: task }, () => {
      if (field === 'contractorId') {
        const {
          NewTaskData: { contractorId },
          lookups: { contractors },
          lookups
        } = this.state
        const found = contractors.find(el => el.id === parseInt(contractorId))
        const lookupObj = Object.assign(lookups)
        lookups.pits = found.pits
        this.setState({ lookups: lookupObj })
      }
      if (field === 'pitId') {
        const {
          NewTaskData: { pitId },
          lookups: { pits },
        } = this.state
        const pit = pits.find(p => p.id === parseInt(pitId))
        this.props.setPitPlanData(pitId)
        this.props.toggleIsLoading(true)
        this.props.getCCsData('', pitId)
        this.props.getDeptsDataByCompany([pit.companyId], isContractor ? { name: 'CONTRACTOR_MANAGEMENT' } : {})
      }
    })
  }

  onSubmitUser() {
    const { userLogin: { userDetail } } = this.props
    const transformed = lo.cloneDeep(this.state.NewTaskData) // deep clone to avoid mutation
    transformed.cc = transformed.cc.map(d => d.id)
    const { photo, contractorId, ...rest } = transformed // trimmed unused keys
    this.setState({ isSubmitDisabled: true }, async () => {
      await submitTask(SUPPORT_REQUEST, { ...rest }, userDetail)
      this.setState({ isSubmitDisabled: false }, () => {
        this.addNewTask()
      })
    })
  }

  addNewTask() {
    this.switchModal(lo.cloneDeep(NewSupportRequest), 'New')  // deep clone from template data and opens the modal
  }

  viewTask(taskData) {
    this.switchModal(taskData, 'View') // pass data from DataTable
  }

  switchModal(taskData, type) {
    this.setState({ [`${type}TaskData`]: taskData }, () => {
      this.setState({ [`isShowModal${type}`]: !this.state[`isShowModal${type}`] })
    })
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage['Support'] = size
    setLocalSettingsTableData(settings)
  }

  renderLeftSection() {
    return (
      <Fragment>
        {this.state.allowCreate &&
          <BtnAddNew
            btnTxt={'Add'}
            disabled={false}
            onClick={() => this.addNewTask()}
            width={'78px'}
          />
        }
        {window.innerWidth >= 900 &&
          <MonthYearInput fn={this.onChangeFilter.bind(this)} val={this.state.filter} />
        }
      </Fragment>
    )
  }

  // RENDER
  render() {
    const { supportRequests, settingsTable, viewState: { isLoading, isMobileView } } = this.props
    const { match: { path }, history: { push }, theme } = this.props

    const sizePerPage = settingsTable.sizePerPage['Support']
    return (
      <Fragment>
        {!isLoading &&
          <TableWrapper>
            {/* ---------- NEW TASK MODAL ---------- */}
            <ModalPage
              isOpen={this.state.isShowModalNew}
              contentChild={
                <SupportRequestModal
                  fnChange={this.onChange.bind(this)}
                  fnSubmit={this.onSubmitUser.bind(this)}
                  fnSwitch={this.switchModal.bind(this, {}, 'New')}
                  newTaskData={this.state.NewTaskData}
                  lookups={this.state.lookups}
                  handleSearchCC={this.onSearchCC.bind(this)}
                  isDisabled={this.state.isSubmitDisabled}
                  {...this.props}
                />
              }
            />
            {/* ---------- VIEW TASK MODAL ---------- */}
            <ModalPage
              isOpen={this.state.isShowModalView}
              fnSwitch={this.switchModal.bind(this, null, 'View')}
              contentChild={
                <SupportRequestView
                  fnSwitch={this.switchModal.bind(this, null, 'View')}
                  taskData={this.state.ViewTaskData}
                  lookups={this.state.lookups}
                  {...this.props}
                />
              }
            />
            {/* ---------- FILTERING IN LOW RES ---------- */}
            {window.innerWidth <= 900 &&
              <div className={'col-12 px-3 pt-3'}>
                <MonthYearInput fn={this.onChangeFilter.bind(this)} val={this.state.filter} />
              </div>
            }
            {/* ---------- DATA TABLE ---------- */}
            <DataTables
              minWidth={'700px'}
              leftSlot={this.renderLeftSection()}
              dataList={supportRequests}
              columnConfig={supportRequestConfig(path, push, theme, this.switchModal.bind(this), isMobileView)}
              sizePerPage={sizePerPage}
              onSizePerPageChange={this.onSizePerPageChange}
            />
            <input id='pickPhoto' hidden type="file" accept="image/*" onChange={e => this.onChange(e.target.files, 'photosBase64')} multiple />
          </TableWrapper>
        }
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    contractorPitLookups: state.contractorPitLookups,
    effectivePitPlan: state.effectivePitPlan,
    supportRequests: state.supportRequests,
    deptLookups: state.supportRequestLookup,
    ccsList: state.ccsList,
    viewState: state.viewState,
    userLogin: state.userLogin,
    deptsList: state.deptsList,
    settingsTable: state.settingsTable,
    globals: state.globals
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsShowTab,
      toggleIsLoading,
      getTaskListData,
      getContractorPitLookupData,
      getCCsData,
      setPitPlanData,
      getLookupByType,
      getDeptsDataByCompany,
      setLocalSettingsTableData,
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SupportRequestList)
  )
)
